import styled from "styled-components";
const LoginPageDisplay = styled.div`
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default LoginPageDisplay;
